import { ButtonProps } from 'modules/queryBuilder/contexts';
import { useTranslation } from 'modules/queryBuilder/hooks/useTranslation';
import { Delete16 } from 'ui/icons';
import { QueryBuilderIconButton } from './QueryBuilderIconButton';
import { BUTTON_VARIANTS } from 'ui/button';

export const DATA_TEST = {
  button: 'remove-requirement-button',
};

export const RemoveRequirementButton = (props: ButtonProps) => {
  const { t } = useTranslation();
  return (
    <QueryBuilderIconButton
      {...props}
      variant={BUTTON_VARIANTS.SECONDARY}
      dataTest={DATA_TEST.button}
      tooltipContent={t('storybook.buttons.tooltips.remove')}
      Icon={Delete16}
    />
  );
};
